import type React from "react";
import { useRowExamples } from "@hooks/jobResults/useRowExamples";
import SimilarExamplesHoverCard from "@components/SimilarExamplesHoverCard/SimilarExamplesHoverCard";

interface TmScoreExamplesTooltipProps {
  jobId: string;
  rowIndex: number;
  /** Rank of the effective match whose examples to show (top / chosen). */
  rank: number | null;
  /** Whether the row has examples at all — drives whether the icon renders. */
  hasExamples: boolean;
}

/**
 * Info icon next to the TM score. On hover it shows the top-5 closest golden
 * examples the backend found: the raw source value, what it was mapped to, and
 * how close. The icon only renders when `hasExamples` is true (the result list
 * ships that flag); the examples themselves load lazily, see useRowExamples.
 */
const TmScoreExamplesTooltip: React.FC<TmScoreExamplesTooltipProps> = ({
  jobId,
  rowIndex,
  rank,
  hasExamples,
}) => {
  const { examples, loading, load } = useRowExamples(jobId, rowIndex, rank);

  if (!hasExamples) return null;

  return (
    <SimilarExamplesHoverCard
      entries={examples}
      loading={loading}
      onOpen={load}
    />
  );
};

export default TmScoreExamplesTooltip;
